import qs from "qs";
import FETCH from "./fetch";

export default {
  transferToNumber(data) {
    if (!data) return;
    Object.keys(data).forEach((key) => {
      let value = data[key];
      if (value != undefined) {
        if (
          (typeof value == "string" && "true" == value.toLowerCase()) ||
          (typeof value == "boolean" && value)
        ) {
          data[key] = 1;
        } else if (
          (typeof value == "string" && "false" == value.toLowerCase()) ||
          (typeof value == "boolean" && !value)
        ) {
          data[key] = 0;
        } else if (typeof value == "object") {
          data[key] = this.transferToNumber(value);
        }
      }
    });
    return data;
  },

  get(url, params = {}) {
    return FETCH.get(url, {
      params: this.transferToNumber(Object.assign({}, params)),
    });
  },

  post(url, requestForm) {
    const interfaceList = [
      "/otc/indexSetting/saveIndexSetting",
      "/otc/indexSetting/submitIndex",
      "/otc/indexSetting/addHospitalIndexBW",
      "/otc/indexSetting/updateIndex",
      "/otc/indexSetting/updateStopIndex",
      "/otc/indexApprove/batchApprove",
      "/otc/indexSetting/updateHospitalLinePre",
      "/otc/indexSetting/addSalesPosition",
      "/fast/UpdateFcstValue",
      "/fast/CreateFcst",
      "/rolesManagement/addUserRoles",
      "/rolesManagement/save",
      // "/fast/findProdFcstList"
      // "/fast/UpdateFcstStatus"
      // "/otc/indexSetting/updateHospRep"
      // "/otc/indexSetting/indexSettingTempExcel"
      // "/otc/indexSetting/addHospitalIndex"
    ];
    // console.log(requestForm, "requestForm====");
    return FETCH.post(
      url,
      // qs.stringify(this.transferToNumber(Object.assign({}, requestForm)))
      interfaceList.indexOf(url) > -1
        ? requestForm
        : qs.stringify(this.transferToNumber(Object.assign({}, requestForm)))
    );
  },

  export(url, params) {
    return exportExcel(FETCH, url, params);
  },

  exportPost(url, params) {
    return exportExcelPost(FETCH, url, params);
  },
  exportPost1(url, params) {
    return exportExcelPost1(FETCH, url, params);
  },
};

function exportExcel(fetch, url, options = {}) {
  return new Promise((resolve, reject) => {
    fetch({
      method: "get",
      url: url,
      data: options,
      responseType: "blob",
    }).then(
      (response) => {
        resolve(response.data);
        let blob = new Blob([response.data], {
          type: "application/vnd.ms-excel",
        });
        let fileName = response.headers["content-disposition"];
        fileName = decodeURIComponent(
          fileName.substring(fileName.indexOf("filename=") + 9)
        ).replace(/\"/g, "");
        // console.log(fileName);
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName);
        } else {
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(link.href);
        }
      },
      (err) => {
        reject(err);
      }
    );
  });
}

function exportExcelPost(fetch, url, options = {}) {
  return new Promise((resolve, reject) => {
    fetch({
      method: "post",
      url: url,
      data: options,
      // data: qs.stringify(transferToNumber(Object.assign({}, options))),
      responseType: "blob",
    }).then(
      (response) => {
        resolve(response.data);
        let blob = new Blob([response.data], {
          type: "application/vnd.ms-excel",
        });
        let fileName = response.headers["content-disposition"];
        fileName = decodeURIComponent(
          fileName.substring(fileName.indexOf("filename=") + 9)
        ).replace(/\"/g, "");
        // console.log(fileName);
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName);
        } else {
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(link.href);
        }
      },
      (err) => {
        reject(err);
      }
    );
  });
}
function exportExcelPost1(fetch, url, options = {}) {
  return new Promise((resolve, reject) => {
    fetch({
      method: "post",
      url: url,
      // data: options,
      data: qs.stringify(transferToNumber(Object.assign({}, options))),
      responseType: "blob",
    }).then(
      (response) => {
        resolve(response.data);
        let blob = new Blob([response.data], {
          type: "application/vnd.ms-excel",
        });
        let fileName = response.headers["content-disposition"];
        fileName = decodeURIComponent(
          fileName.substring(fileName.indexOf("filename=") + 9)
        ).replace(/\"/g, "");
        console.log(fileName);
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName);
        } else {
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(link.href);
        }
      },
      (err) => {
        reject(err);
      }
    );
  });
}
function transferToNumber(data) {
  if (!data) return;
  Object.keys(data).forEach((key) => {
    let value = data[key];
    if (value != undefined) {
      if (
        (typeof value == "string" && "true" == value.toLowerCase()) ||
        (typeof value == "boolean" && value)
      ) {
        data[key] = 1;
      } else if (
        (typeof value == "string" && "false" == value.toLowerCase()) ||
        (typeof value == "boolean" && !value)
      ) {
        data[key] = 0;
      } else if (typeof value == "object") {
        data[key] = transferToNumber(value);
      }
    }
  });
  return data;
}



// WEBPACK FOOTER //
// ./src/api/http.js